import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { GEO_REGION } from "../apiRoutes";

// Define the expected response type (adjust based on your API response)
export interface GeoRegion {
  id: string;
  name: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}

export interface GeoRegionsResponse {
  data: {
    records: GeoRegion[];
    pagination: { totalRecords: number }[];
  }[];
}

const fetchGeoRegions = async ({ data }: { data: FieldValues }) => {
  const response = await axiosAuth.get<GeoRegionsResponse>(GEO_REGION, {
    params: data,
  });
  return response.data;
};

// Query hook
const useGeoRegionsQuery = (
  data: FieldValues,
  queryParams?: Omit<
    UseQueryOptions<
      GeoRegionsResponse,
      Error,
      GeoRegionsResponse,
      ["geoRegions", FieldValues]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<
    GeoRegionsResponse,
    Error,
    GeoRegionsResponse,
    ["geoRegions", FieldValues]
  >({
    queryKey: ["geoRegions", data],
    queryFn: () => fetchGeoRegions({ data }),
    ...(queryParams || {}),
  });

export default useGeoRegionsQuery;
